'use strict';

module.exports = require('./Trigger');


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-cascader/~/rc-trigger/lib/index.js
 ** module id = 323
 ** module chunks = 0
 **/